import { IconSparkles } from "@tabler/icons-react";
import { Card, Divider, Group, Stack, Text, ThemeIcon } from "@/components/ui";
import { ResourceLink } from "./ResourceLink";

/**
 * Card de links a documentación del portal. El link al Hangfire dashboard
 * solo aparece para Administradores · es el único protegido por rol acá
 * (el resto son docs estáticos).
 */
export function RecursosCard({ esAdmin }: { esAdmin: boolean }) {
  return (
    <Card padding="lg">
      <Stack gap="md">
        <Group gap="sm">
          <ThemeIcon variant="light" color="slate" size="lg">
            <IconSparkles size={16} />
          </ThemeIcon>
          <Stack gap={0}>
            <Text fw={600} size="sm">
              Recursos
            </Text>
            <Text size="xs" c="dimmed">
              Documentación del portal
            </Text>
          </Stack>
        </Group>
        <Divider />
        <Stack gap={6}>
          <ResourceLink label="Guion de demo" href="/DEMO-STORY.md" external />
          <ResourceLink label="Contexto del modelo" href="/docs/contexto-multiva.md" external />
          {esAdmin ? <ResourceLink label="Hangfire dashboard" href="/hangfire" external /> : null}
        </Stack>
      </Stack>
    </Card>
  );
}
